import React, { useEffect, useRef, useState } from 'react';
import { getDuration } from './helpers';

export function NumberCounter({
  startCount = 0,
  endCount,
  duration = 500,
  formatAsTime = false,
}) {
  const [count, setCount] = useState(startCount);
  const countRef = useRef(count);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          const interval = setInterval(() => {
            const diff = endCount - startCount;
            const increment = diff / (duration / 10);
            const nextCount = countRef.current + increment;

            if (nextCount <= endCount) {
              countRef.current = nextCount;
              setCount(nextCount);
            } else {
              countRef.current = endCount;
              setCount(endCount);
              clearInterval(interval);
            }
          }, 10);

          return () => clearInterval(interval);
        }
      },
      { threshold: 1.0 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [startCount, endCount, duration]);

  return (
    <span className="counter" ref={elementRef}>
      {formatAsTime ? getDuration(count) : Math.ceil(count)}
    </span>
  );
}
